import styles from './catalog.module.scss';
import { Box, Container } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';
import PageTitle from '../../page-title/page-title';
import { useCourseGetRequestHook } from '../../requestUtils';
import CatalogGrid from './catalog-grid/catalog-grid';
import { ICatalog } from '../../_models/catalog';
import CatalogGridSkeleton from './catalog-grid/catalog-grid-skeleton';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface CatalogProps { }

export function Catalog(props: CatalogProps) {
  const { data: catalog, isLoading, getData: getCatalog }: { data: ICatalog[], isLoading: boolean, getData: () => void } = useCourseGetRequestHook("catalog/getAll", []);
  const { t } = useTranslation();

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("app.courseCatalog")} subtitle={`(${t("standard.admin")})`} />
            {isLoading ? <CatalogGridSkeleton /> :
              <CatalogGrid
                catalog={catalog}
                refreshData={getCatalog}
              />
            }
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default Catalog;